export default {
  tab: {
    index: 'Summary',
    fundamental: 'Fundamental',
    news: 'News',
    technical: 'Technical',
    performance: 'Performance',
  },
  MY_WATCHLIST: 'My WatchList',
  INDUSTRIES: 'Industries',
  DERIVATIVES: 'Derivatives',
  INDEX: 'Index Future',
  BONDS: 'Bond Future',
  PUT_THROUGH: 'Put Through',
  COVERED_WARRANT: 'Covered Warrant',
  add: 'Add',
  done: 'Done',
  addToWatchlist: 'Add to Watchlist',
  from: 'From',
  to: 'to',
};
